var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M391.184,257.437c-0.199,0-0.402-0.063-0.575-0.193c-0.138-0.106-13.838-10.783-5.769-28.88   c0.214-0.48,0.777-0.692,1.259-0.482c0.48,0.216,0.696,0.777,0.482,1.259c-7.443,16.687,4.662,26.191,5.181,26.587   c0.418,0.318,0.498,0.915,0.18,1.333C391.755,257.307,391.472,257.437,391.184,257.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M383.293,241.806c-0.037,0-0.074-0.002-0.112-0.006c-0.523-0.061-0.896-0.534-0.837-1.056   c0.396-3.422,1.683-5.81,3.827-7.097c3.45-2.074,7.761-0.417,7.941-0.344c0.489,0.192,0.729,0.742,0.537,1.231   c-0.192,0.489-0.746,0.733-1.231,0.541c-0.037-0.015-3.638-1.382-6.277,0.208c-1.605,0.969-2.583,2.879-2.905,5.68   C384.182,241.449,383.769,241.806,383.293,241.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M385.88,229.532c-0.082-0.21-2.141-5.098-11.447-3.018c-10.539,2.362-10.662,16.263-10.662,16.403   c0,0.478,0.355,0.883,0.831,0.945c0.041,0.006,0.082,0.007,0.121,0.007c0.428,0,0.811-0.288,0.921-0.71   c3.928-14.962,18.556-12.449,19.178-12.339c0.351,0.063,0.69-0.067,0.908-0.331C385.951,230.22,386.008,229.854,385.88,229.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M383.687,237.283c0,0-6.348-4.047-8.966,1.111s-0.635,10.712,0.397,12.934   c0,0,3.784-4.183,7.379-4.761c4.444-0.714,5.554-6.269,2.46-9.046C381.259,234.203,383.687,237.283,383.687,237.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M390.622,227.803c-0.091,5.553,3.004,6.282,3.004,6.282   C395.629,228.986,390.622,227.803,390.622,227.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M389.653,239.469c0.042-5.27,3.617-5.862,3.617-5.862   C395.436,238.506,389.653,239.469,389.653,239.469z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M410.269,235.22c0,0-5.053-0.747-6.992-1.662c-1.613-0.762-3.719-2.599-6.444-2.24  c-2.083,0-3.772,1.689-3.772,3.772s1.431,4.579,8.917,4.025c3.63-0.269,6.721,1.389,6.721,1.389  C408.223,238.519,410.269,235.22,410.269,235.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M405.025,236.873c0,0-7.752,0.538-9.455-0.717c-1.572-1.158-1.161-3.003,0.448-3.181  C398.438,232.706,405.025,236.873,405.025,236.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B49B91"
    },
    d: "M420.108,245.654l-17.139,10.712l-1.964-1.904l9.403-9.105l2.202,0.893l2.142-2.857l-5.118-2.678  c0,0-13.569,12.795-25.114,13.866c-3.884,0.36-7.842,0.107-10.928-1.164l-6.925,9.972l14.521,12.378l21.305-0.833l17.615-23.924  l3.095,1.428l2.618-3.095L420.108,245.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8278"
    },
    d: "M372.343,274.497c-4.768,0-8.648-3.879-8.648-8.646c0-4.768,3.879-8.648,8.648-8.648  c4.766,0,8.646,3.879,8.646,8.648C380.989,270.617,377.109,274.497,372.343,274.497z M372.343,260.06  c-3.193,0-5.791,2.598-5.791,5.791s2.598,5.789,5.791,5.789s5.789-2.596,5.789-5.789S375.536,260.06,372.343,260.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M408.365,282.512c0,0,1.587-1.032,3.174-5.872l-3.253,0.476c0,0,0.635-2.698-0.079-4.682   l-3.65,2.857c0,0-1.666-3.491-2.38-3.967c0,0-2.539,3.571-3.967,4.047c0,0-1.428-5.158-2.857-6.189l-2.46,3.491l-3.65-2.857   c0,0,0,2.46-0.079,3.015c-0.079,0.555-4.761-4.92-4.761-4.92s-2.063,0.873-4.84,5.316l-3.491-3.571l-1.428,4.682l-4.84-1.27   l0.793,2.777l-4.205-0.317c0,0,0.714,4.126,2.777,5.554L408.365,282.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M366.31,300.167c0,0-13.092,16.663-37.849,14.759l26.899,3.69l13.807-13.092L366.31,300.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M323.581,312.426c2.618,1.904,18.806,6.546,30.47,0.952c0,0,0.238,2.738-1.071,4.285   c0,0,8.57-3.452,13.212-9.879s-9.641,13.807-9.641,13.807l-21.9,4.047l-8.927-7.379L323.581,312.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M321.86,252.422c-2.908,0.244-6.054,1.995-7.662,4.122c-0.876-0.372-2.823-0.538-4.436,0.538   c-2.148,1.432-6.117,6.604-9.45,5.236c0,0-0.298,4.88,4.88,4.701c0,0-1.309,2.023-1.071,5.237s-2.083,5.356-2.083,5.356   s10.474,1.488,10.891-6.665c0.051-0.997,0.101-1.874,0.15-2.657c5.466,2.952,7.617-1.215,7.617-1.215s-3.284-3.102,0.059-7.52   s12.533,5.997,12.533,5.997C333.465,261.383,333.092,251.478,321.86,252.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M362.342,279.893c0,0-3.015,2.063-12.378,0.159c0,0,2.063-4.602,1.111-7.3   c0,0-2.539,2.38-8.728,4.761c-6.189,2.38-13.807,9.998-16.028,14.918c0,0,13.92-32.088,2.738-35.35   c-3.835-1.119-7.134,0.695-8.302,2.474c0.564,0.667,1.106,1.615,1.161,2.882c0.119,2.738-2.618,21.186-6.665,33.921   c0,0-1.19-4.404-3.095-6.546c-1.904-2.142-3.333-5.594-3.333-5.594s-3.214,2.142-2.738,6.07c0,0-1.785-1.428-5.237-0.476   s-4.761-1.309-4.761-1.309s-2.857,7.617,5.594,11.545c0,0-2.261,1.071-3.333,1.904c-1.071,0.833-2.738,0.833-2.738,0.833   s2.976,5.475,9.284,6.07c6.308,0.595,9.208,2.394,11.188,5.634c6.427,10.514,18.726,18.488,38.801,6.189   c0,0-28.565,8.887-29.835-9.363c-1.111-15.965,16.346-19.202,18.091-15.711c1.746,3.491-0.159,6.507-0.159,6.507   s9.522-2.222,4.92-10.95C347.901,291.16,357.264,292.589,362.342,279.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M454.03,312.426c-2.618,1.904-19.163,9.046-30.589-2.38s-15.882-28.582-15.235-26.661H396.78   l3.809,34.279l42.372,7.975l8.927-7.379L454.03,312.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M455.751,252.422c2.908,0.244,6.054,1.995,7.662,4.122c0.876-0.372,2.823-0.538,4.436,0.538   c2.148,1.432,6.117,6.604,9.45,5.236c0,0,0.298,4.88-4.88,4.701c0,0,1.309,2.023,1.071,5.237c-0.238,3.214,2.083,5.356,2.083,5.356   s-10.474,1.488-10.891-6.665c-0.051-0.997-0.101-1.874-0.15-2.657c-5.466,2.952-7.617-1.215-7.617-1.215s3.284-3.102-0.059-7.52   s-12.533,5.997-12.533,5.997C444.145,261.383,444.519,251.478,455.751,252.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M415.268,279.893c0,0,3.015,2.063,12.378,0.159c0,0-2.063-4.602-1.111-7.3  c0,0,2.539,2.38,8.728,4.761c6.189,2.38,13.807,9.998,16.028,14.918c0,0-13.92-32.088-2.738-35.35  c3.835-1.119,7.134,0.695,8.302,2.474c-0.564,0.667-1.106,1.615-1.161,2.882c-0.119,2.738,2.618,21.186,6.665,33.921  c0,0,1.19-4.404,3.095-6.546c1.904-2.142,3.333-5.594,3.333-5.594s3.214,2.142,2.738,6.07c0,0,1.785-1.428,5.237-0.476  s4.761-1.309,4.761-1.309s2.857,7.617-5.594,11.545c0,0,2.261,1.071,3.333,1.904s2.738,0.833,2.738,0.833s-2.976,5.475-9.284,6.07  c-6.308,0.595-9.208,2.394-11.188,5.634c-6.427,10.514-18.726,18.488-38.801,6.189c0,0,28.565,8.887,29.835-9.363  c1.111-15.965-16.346-19.202-18.091-15.711c-1.746,3.491,0.159,6.507,0.159,6.507s-9.522-2.222-4.92-10.95  C429.709,291.16,420.346,292.589,415.268,279.893z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M407.174,306.554c4.682,6.824,11.188,13.013,30.073,18.885s23.932,6.745,33.829,14.749   c0,0,1.88,1.985,2.6,5.168c0.845,3.738-4.92,14.521-4.92,14.521s0.555-2.539-2.936-7.459s-24.122-13.807-34.913-16.504   c-10.791-2.698-29.439-15.215-24.281-24.598L407.174,306.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M471.059,340.158c0.007,0.01,0.011,0.02,0.018,0.03c-0.012-0.013-0.022-0.026-0.034-0.039   L471.059,340.158z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M470.582,363.368c0,0,0.476,3.452-2.38,6.427c-2.857,2.976-4.88,5.118-4.761,7.617   c0,0-4.285-3.095-3.571-9.998c0,0-5.594,4.642-14.045,0.119c0,0,0.833-8.451,11.783-9.522c0,0-4.285-3.333,1.309-8.451   c0,0,0.65,2.288,5.713,3.452c4.404,1.012,12.24-4.511,6.446-12.825C481.056,351.465,475.938,359.202,470.582,363.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M403.088,300.286c0,0,2.413,3.945,8.689,7.776c7.538,4.602,8.213,6.745,8.213,6.745l-5.118-0.119   c0,0,6.546,3.571,8.332,8.094c0,0-2.738,0.476-5.832-0.357c0,0,2.499,2.261,1.309,9.522h-12.735L403.088,300.286z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M377.736,332.898v-30.47c0,0-10.342,17.693-19.275,30.47H377.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M368.84,301.793c-2.539,4.602-10.474,19.758-29.359,25.63s-22.337,4.761-32.234,12.765  c0,0-1.88,1.985-2.6,5.168c-0.845,3.738,4.92,14.521,4.92,14.521s-0.555-2.539,2.936-7.459s24.006-14.324,34.913-16.504  c15.085-3.015,28.733-19.202,26.511-29.676C371.706,295.763,368.84,301.793,368.84,301.793z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.266,340.158c-0.007,0.01-0.011,0.02-0.018,0.03c0.012-0.013,0.022-0.026,0.034-0.039   L307.266,340.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.742,363.368c0,0-0.476,3.452,2.38,6.427c2.857,2.976,4.88,5.118,4.761,7.617   c0,0,4.285-3.095,3.571-9.998c0,0,5.594,4.642,14.045,0.119c0,0-0.833-8.451-11.783-9.522c0,0,4.285-3.333-1.309-8.451   c0,0-0.65,2.288-5.713,3.452c-4.404,1.012-12.24-4.511-6.446-12.825C297.268,351.465,302.386,359.202,307.742,363.368z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M334.095,414.151c0,0,2.698,12.14,2.857,24.677c0,0,11.823,0.397,17.536-8.49  c0,0-11.426-5.951-17.536-17.457L334.095,414.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M331.555,387.331c-0.476-5.713,2.063-20.155,13.648-30.629l0.284-12.826c0,0-3.45,0.358-6.512,3.038  l-6.547,10.146l-6.07,22.971L331.555,387.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M331.873,391.457c0,0,0,12.22,5.078,21.424l-2.857,1.27c0,0-10.236-8.054-12.378-24.598  c0,0-9.165,6.07-12.537-6.348c0,0,9.839,3.967,13.013-5.078c2.864-8.162,5.757-23.02,16.783-31.213  c-5.241,8.055-13.133,28.673-7.023,35.973c1.618,1.933,6.269,3.571,11.359,1.397C342.978,388.345,341.042,394.55,331.873,391.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE5A"
    },
    d: "M333.355,416.318l-1.671-3.072c-0.292-0.537-0.094-1.21,0.444-1.503l3.051-1.659  c0.537-0.292,1.21-0.094,1.502,0.444l1.671,3.072c0.292,0.537,0.094,1.21-0.444,1.503l-3.051,1.659  C334.32,417.054,333.647,416.855,333.355,416.318z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M436.613,414.151c0,0-2.698,12.14-2.857,24.677c0,0-11.823,0.397-17.536-8.49   c0,0,11.426-5.951,17.536-17.457L436.613,414.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M439.152,387.331c0.476-5.713-2.063-20.155-13.648-30.629l-0.284-12.826c0,0,3.45,0.358,6.512,3.038   l6.547,10.146l6.07,22.971L439.152,387.331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M427.396,384.284c5.09,2.174,9.741,0.536,11.359-1.397c6.11-7.3-1.782-27.918-7.023-35.973  c11.026,8.192,13.919,23.05,16.783,31.213c3.174,9.046,13.013,5.078,13.013,5.078c-3.372,12.418-12.537,6.348-12.537,6.348  c-2.142,16.544-12.378,24.598-12.378,24.598l-2.857-1.27c5.078-9.204,5.078-21.424,5.078-21.424  C429.665,394.55,427.729,388.345,427.396,384.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE5A"
    },
    d: "M437.352,416.318l1.671-3.072c0.292-0.537,0.094-1.21-0.444-1.503l-3.051-1.659  c-0.537-0.292-1.21-0.094-1.502,0.444l-1.671,3.072c-0.292,0.537-0.094,1.21,0.444,1.503l3.051,1.659  C436.387,417.054,437.06,416.855,437.352,416.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M347.266,329.089c-2.103,0-3.809,1.705-3.809,3.809v41.896c0,11.426,3.809,53.322,41.896,68.557  c38.087-15.235,41.896-57.131,41.896-68.557v-41.896c0-2.104-1.705-3.809-3.809-3.809H347.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M383.045,329.089l-36.122,69.231c0.904,3.202,2.032,6.516,3.447,9.864l34.983-67.053l34.983,67.053  c1.415-3.348,2.543-6.663,3.447-9.864l-36.122-69.231H383.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M420.337,408.184l-34.983-67.053l-34.983,67.053l0,0c5.762,13.638,16.188,27.649,34.984,35.167  C404.149,435.833,414.576,421.822,420.337,408.184L420.337,408.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M399.517,412.524l2.304,1.105c-0.966,1.427-2.977,3.738-6.823,5.83  c-2.905,1.581-5.713,3.452-7.74,4.885v-31.432l9.522-0.979v-3.809l-9.522-0.979v-4.734c0-1.052-0.853-1.904-1.904-1.904  c-0.897,0-1.614,0.633-1.816,1.468c-0.633-0.453-1.367-0.776-2.203-0.776c-2.131,0-3.866,1.735-3.866,3.866  c0,1.003,0.408,1.9,1.037,2.589l-4.578,0.471v3.809l9.522,0.979v31.432c-2.027-1.434-4.835-3.305-7.74-4.885  c-3.846-2.092-5.857-4.403-6.823-5.83l2.304-1.105l-8.689-11.069v15.235l2.929-1.404c1.159,1.867,3.609,4.881,8.46,7.519  c4.058,2.209,7.997,5.079,9.559,6.255l1.904,1.477l1.904-1.477c1.561-1.175,5.5-4.046,9.559-6.255  c4.852-2.638,7.302-5.652,8.46-7.519l2.929,1.404v-15.235L399.517,412.524z M381.335,387.027c-1.082,0-1.962-0.88-1.962-1.962  s0.88-1.962,1.962-1.962s1.962,0.88,1.962,1.962S382.417,387.027,381.335,387.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M388.556,378.603h-6.405c-1.387,0-2.511-1.124-2.511-2.511v-10.213c0-1.387,1.124-2.511,2.511-2.511  h6.405c1.387,0,2.511,1.124,2.511,2.511v10.213C391.067,377.478,389.943,378.603,388.556,378.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B49B91"
    },
    d: "M412.015,329.089c-7.617-11.426-7.617-34.279-7.617-34.279s0-15.235-19.044-15.235  c-9.647,0-14.398,3.909-16.746,7.767c-9.14,3.673-13.724,11.276-13.724,11.276c3.897,1.948,7.339,2.877,10.462,3.115  c6.209,7.389,8.274,14.524,8.824,19.656c-3.576,3.653-5.56,12.46-0.243,19.125c0,0,11.267-2.618,20.779-11.426L412.015,329.089  L412.015,329.089z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8278"
    },
    d: "M394.706,329.089h14.214C408.206,322.067,401.303,323.198,394.706,329.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8278"
    },
    d: "M408.566,321.899c-4.163-11.817-4.169-27.088-4.169-27.088s-0.001-0.248-0.04-0.676   c-4.959-0.673-10.034-0.308-19.956,3.532c-10.564,4.089-15.734,4.206-19.055,4.067c6.209,7.389,8.274,14.524,8.824,19.656   l0.154,8.096c0,0,5.951,0.873,19.044-6.665C399.898,319.061,405.434,318.739,408.566,321.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8278"
    },
    d: "M388.289,293.144c7.726-1.932,12.655-1.733,15.83-0.604c-0.851-4.243-4.348-12.964-18.765-12.964   c-9.647,0-14.398,3.909-16.746,7.767l-5.789,8.102C362.819,295.445,370.06,297.702,388.289,293.144z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M372.767,277.909c0.751,0.748,2.988,6.144,2.526,6.946c-0.297,0.516-6.256,1.997-7.223,1.241  c-0.862-0.674-1.871-6.486-1.293-7.156C367.301,278.334,372.14,277.285,372.767,277.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M380.431,277.622c0.691,0.793,2.259,6.068,1.638,6.741c-0.4,0.433-7.043,0.957-7.965,0.126  c-0.822-0.741-1.004-6.226-0.278-6.761C374.483,277.244,379.854,276.96,380.431,277.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M387.684,277.421c0.717,0.747,2.353,5.707,1.711,6.337c-0.412,0.405-7.284,0.882-8.24,0.099  c-0.853-0.698-1.054-5.852-0.305-6.353C381.529,277.052,387.085,276.798,387.684,277.421z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M395.054,277.766c0.634,0.816,1.831,6.02,1.165,6.623c-0.429,0.388-7.09,0.405-7.952-0.465   c-0.769-0.775-0.568-6.08,0.193-6.542C389.149,276.964,394.525,277.085,395.054,277.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M410.267,280.92c0.491,0.909,0.443,5.744-0.314,6.228c-0.487,0.312-6.485-0.759-7.192-1.758   c-0.63-0.892,0.444-6.09,1.271-6.42C404.781,278.671,409.857,280.161,410.267,280.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M403.277,278.859c0.602,0.827,1.059,5.68,0.334,6.193c-0.466,0.33-7.33-0.234-8.162-1.132  c-0.742-0.801-0.199-5.803,0.614-6.175C396.799,277.409,402.775,278.168,403.277,278.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8278"
    },
    d: "M374.652,264.63c1.088,2.342-1.188,4.618-3.53,3.53c-0.476-0.221-0.869-0.614-1.09-1.09  c-1.088-2.342,1.188-4.618,3.53-3.53C374.038,263.761,374.431,264.154,374.652,264.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/PN.b52fbf1e0abd7b8ab4ed075965592937.svg";
export { ForwardRef as ReactComponent };